import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";

import AB_2659 from "./AB_2659";
import AB_3274 from "./AB_3274";
import AB_3422 from "./AB_3422";
import AB_3632 from "./AB_3632";
import AB_4409_v2 from "./AB_4409_v2";
import AB_4409_v3 from "./AB_4409_v3";
import AB_4409_v4 from "./AB_4409_v4";
import AB_4409_v5 from "./AB_4409_v5";
import Default from "./Default";

const abTests = {
    dev_4409__v2: loadUsualComponent(AB_4409_v2),
    dev_4409__v3: loadUsualComponent(AB_4409_v3),
    dev_4409__v4: loadUsualComponent(AB_4409_v4),
    dev_4409__v5: loadUsualComponent(AB_4409_v5),
    dev_3274__v2: loadUsualComponent(AB_3274),
    dev_3632__v2: loadUsualComponent(AB_3632),
    dev_3422__v2: loadUsualComponent(AB_3422),
    dev_2659__v2: loadUsualComponent(AB_2659),
};

const List = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default List;
